import {helpers} from '@vuelidate/validators';
import {parsePhoneNumberWithError} from 'libphonenumber-js';

export const passwordPattern = value => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true;
  }
  return /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!-\/:-@\[-`{-~])\S{8,30}$/.test(value);
};

export const phoneNumberPattern = (param) =>
  helpers.withParams(
    { type: 'phoneNumberPattern', value: param },
    (value) => {
      if (typeof value === 'undefined' || value === null || value === '') {
        return true;
      }

      try {
        /** @type {PhoneNumber} */
        const phoneNumber = parsePhoneNumberWithError(value, param);
        return phoneNumber.isValid();
      } catch {
        return false;
      }
    }
  )

// Comparaison de 2 dates provenant des calendriers FullCalendar
export const appointmentEndTimeGreaterThan = (param) =>
  helpers.withParams(
    { type: 'appointmentEndTimeGreaterThan', value: param },
    (value) => {
      return value > new Date(param)
    }
  )

export const numberArrayPattern = values => {
  if (typeof values === 'undefined' || values === null || values === '') {
    return true;
  }

  for(const value of values) {
    if(isNaN(Number(value)) || !Number.isInteger(Number(value))) return false;
  }
  return true;
}


export const maxBarcode = val =>{
  return val <= 1000
}

export const isAfterDate = (date) =>
  helpers.withParams(
    { type: 'isAfterDate', value: date },
    (value) => {
      if (typeof value === 'undefined' || value === null || value === '') {
        return true;
      }

      return new Date(value) > new Date(date);
    }
  )
